export default __webpack_public_path__ + "static/media/rating.33786d89.svg";